// contexts/ConfigContext.js
import React, { createContext, useState, useContext, useEffect } from 'react';
import API_URL from '../config';

const ConfigContext = createContext();

export const ConfigProvider = ({ children }) => {
  // Valores por defecto (no deja la pantalla en blanco)
  const defaultConfig = {
    colorPrincipalPublica: '#000000', // Amarillo por defecto
    mostrarBlog: true,
  };

  const [config, setConfig] = useState(() => {
    // Intentar cargar de localStorage si existe
    const storedConfig = localStorage.getItem('appConfig');
    return storedConfig ? JSON.parse(storedConfig) : defaultConfig;
  });

  const [loading, setLoading] = useState(false);

  const cargarConfiguracion = async () => {
    setLoading(true);
    try {
      const response = await fetch(`${API_URL}/configuracion`);
      if (!response.ok) throw new Error('Error al obtener configuración');
      const data = await response.json();

      const newConfig = {
        colorPrincipalPublica: data.colorPrincipalPublica || defaultConfig.colorPrincipalPublica,
        mostrarBlog: data.mostrarBlog ?? defaultConfig.mostrarBlog,
      };

      setConfig(newConfig);
      localStorage.setItem('appConfig', JSON.stringify(newConfig));
    } catch (error) {
      console.error('Error al cargar configuración:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    cargarConfiguracion();
  }, []);

  return (
    <ConfigContext.Provider value={{ config, setConfig, cargarConfiguracion, loading }}>
      {children}
    </ConfigContext.Provider>
  );
};

export const useConfig = () => {
  const context = useContext(ConfigContext);
  if (!context) {
    throw new Error('useConfig debe usarse dentro de un ConfigProvider');
  }
  return context;
};
